export const MainConfig = {
    AppDetails: {
        app_name: "Nubeli RD",
        app_description: "Car service",
        app_identifier: "com.nubeli.rd",
        app_json_version: "20.0",
        android_build_version: 20,
        android_local_version: "20.0",
        ios_driver_local_version: "20.0",
        ios_rider_local_version: "20.0",
        web_name: "NubeLi RD",
        app_store_url_driver: "https://apps.apple.com/do/app/nubeli-rd-driver/id6738397677",
        app_store_url_passenger: "https://apps.apple.com/do/app/nubeli-rd/id6738397455"
    },
    GuestUrlRideDetails: "https://dashboard-rd.nubeliny.com/guest-ride-details",
    FirebaseConfig: {
        apiKey: "AIzaSyDGyddb6tWcrlX728X3awelZAp5Js23Ixc",
        authDomain: "nubeli-rd.firebaseapp.com",
        databaseURL: "https://nubeli-rd-default-rtdb.firebaseio.com",
        projectId: "nubeli-rd",
        storageBucket: "nubeli-rd.firebasestorage.app",
        messagingSenderId: "296608602077",
        appId: "1:296608602077:web:9db684470f574726630834",
        measurementId: "G-WSESRZR6ZY"
    },
    Google_Map_Key: "AIzaSyAc5sQBFEifptgBnP3FWzWo1-UDjSBB-AE",
    facebookAppId: "",
    PurchaseDetails: {
        CodeCanyon_Purchase_Code: "b0c2b874-532a-462a-b9e2-ac316daffcd7",
        Buyer_Email_Address: "gerencia@husogroup.com.co"
    }
}